var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.40625 5C4.40625 4.73478 4.51161 4.48043 4.69914 4.29289C4.88668 4.10536 5.14103 4 5.40625 4H7.55925C7.79596 4.00011 8.02495 4.08418 8.20549 4.23726C8.38604 4.39034 8.50643 4.6025 8.54525 4.836L9.28525 9.271C9.32061 9.48222 9.28722 9.69921 9.19001 9.89003C9.0928 10.0809 8.9369 10.2354 8.74525 10.331L7.19725 11.104C7.75236 12.4797 8.57908 13.7293 9.62803 14.7782C10.677 15.8272 11.9266 16.6539 13.3022 17.209L14.0763 15.661C14.1718 15.4695 14.3262 15.3138 14.5168 15.2166C14.7074 15.1194 14.9242 15.0859 15.1353 15.121L19.5702 15.861C19.8038 15.8998 20.0159 16.0202 20.169 16.2008C20.3221 16.3813 20.4061 16.6103 20.4062 16.847V19C20.4062 19.2652 20.3009 19.5196 20.1134 19.7071C19.9258 19.8946 19.6715 20 19.4062 20H17.4062C10.2263 20 4.40625 14.18 4.40625 7V5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.3d31566eb3a3958cc7ed4fb33ee05a2f.svg";
export { ForwardRef as ReactComponent };